import React from "react";

const ScontrinoWrapper = ({ children }) => {
  return (
    <div className=" shadow-2xl rounded-md h-[calc(100vh-4em)] w-full flex flex-col overflow-scroll px-2 md:px-10 xl:px-20  dark:bg-gray-800 md:text-xl">
      {children}
    </div>
  );
};

export default ScontrinoWrapper;
